// extracted by mini-css-extract-plugin
module.exports = {"rootClassName":"sicredi-logo"};